import {
  AppBar,
  Box,
  Grid,
  Stack,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SendCompareB from "../../pages/ComparePage/components/SendCompareB";
import SendProposalB from "../../pages/ProposalPage/components/SendProposalB";
import SendQuoteB from "../../pages/QuotesPage/components/SendQuoteB";
import { useGetFrontendBoot } from "../../services";
import { Actions } from "../../slices/actions";
import { leadDataSelector, quoteSelector } from "../../slices/selectors";
import Modal from "../Modal";
import TraceIdButton from "../TraceIdButton/TraceIdButton";
import EditDetails from "../TravelEdit/EditDetails";
import HeaderData from "./HeaderData";
import HeaderProfile from "./HeaderProfile";
const logoPath = require(`../../assets/images/${process.env.REACT_APP_TENANT}Logo.png`);

const Header = ({ userData }) => {
  const theme = useTheme();
  const { settings } = useGetFrontendBoot();
  const { showEdit } = useSelector(quoteSelector);
  const navigate = useNavigate();
  const leadData = useSelector(leadDataSelector);
  const { pathname: path } = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const openEdit = () => {
     Actions.clearCompareQuote()

    Actions.setDisableMembers(false);
    Actions.setShowEdit(true);
  };
  const closeEdit = () => Actions.setShowEdit(false);
  const closeEditModal = () => {
    Actions.setShowEdit(false);
    Actions.setEditMode("default");
  };

  return (
    <>
      <Grid container>
        <AppBar
          sx={{
            boxShadow: "none",
            borderBottom: isMobile ? "none" : "2px solid var(--primary-light)",
            paddingRight: "0",
          }}
        >
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Box>
              <img
                src={settings?.logo || logoPath}
                style={{
                  cursor: "pointer",
                  paddingLeft: isMobile ? "0px" : "30px",
                }}
                onClick={() => {
                  navigate("/");
                  Actions.setActiveStep(0);
                }}
                width={isMobile ? "124px" : "200px"}
                alt="Logo"
              />
            </Box>
            <Box
              sx={{ paddingRight: isMobile ? "0px" : "22px", display: "flex" }}
            >
              <Stack direction="row" spacing={-4}>
                <Toolbar>
                  {path === "/quote" && <HeaderData onClick={openEdit} />}
                  {!isMobile &&
                    ({
                      "/quote": <SendQuoteB />,
                      //  "/shortlisted-quotes": <SendQuoteB />,
                      "/compare": <SendCompareB />,
                      "/proposal": (
                        <>
                          <TraceIdButton />
                          <SendProposalB />
                        </>
                      ),
                      "/thank-you": <TraceIdButton />,
                    }[path] ||
                      null)}
                </Toolbar>
              </Stack>
              <HeaderProfile sellerData={userData || leadData} />
            </Box>
          </Toolbar>
        </AppBar>
      </Grid>
      <Modal maxWidth={"900px"} open={showEdit} handleClose={closeEditModal}>
        <EditDetails handleClose={closeEdit} />
      </Modal>
    </>
  );
};

export default Header;
